import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { Cliente } from '../modelo/cliente';
import { Contrato } from '../modelo/contrato';
import { DebitoAutomaticoContratoDetalhe } from '../modelo/debito-automatico-contrato-detalhe';
import { Config } from '../services/config';
import { DebitoAutomaticoService } from '../services/debitoautomatico.service';
import { MensagemService } from '../services/mensagem.service';
import { RestClientService } from '../services/restclient.service';
import { SegundaViaService } from '../services/segundavia.service';
import { SessaoService } from '../services/sessao.service';
import { AbstractComponent } from '../util/abstract.component';

declare var $: any;

@Component({
  selector: 'app-debito-automatico',
  templateUrl: './debito-automatico.component.html',
  styleUrls: ['./debito-automatico.component.css'],
  providers: [SegundaViaService, DebitoAutomaticoService, MensagemService, RestClientService]
})
export class DebitoAutomaticoComponent extends AbstractComponent implements OnInit {

  cliente: Cliente = new Cliente();

  constructor(
    private sessaoService: SessaoService,
    private segundaViaService: SegundaViaService,
    private mensagemService: MensagemService,
    private spinnerService: Ng4LoadingSpinnerService,
    private debitoAutomaticoService: DebitoAutomaticoService,
    private router: Router,
    public dialog: MatDialog) {
    super(sessaoService);
  }

  ngOnInit() {
    // Menu
    $(".btsMenu .btn").removeClass("active activeDrop");
    $(".debito").addClass("active");

    //Scroll top
    window.scrollTo(0, 0);
    this.buscaContratos();

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function () {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
  }

  buscaContratos = (): void => {
    this.segundaViaService.listarContrato().subscribe(
      (result: Cliente) => {
        this.cliente = result;
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  consultarContratoDebitoAutomatico = (contrato: Contrato, route: string): void => {
    let debitoAutomaticoContratoDetalhe = new DebitoAutomaticoContratoDetalhe();
    this.debitoAutomaticoService.consultarContratoDebitoAutomatico(contrato).subscribe(
      (result: DebitoAutomaticoContratoDetalhe) => {
        if (result.cdMsgemRetorno == "0") {
          debitoAutomaticoContratoDetalhe = result;
          sessionStorage.setItem('debitoAutomaticoContratoDetalhe', JSON.stringify(debitoAutomaticoContratoDetalhe));
          sessionStorage.setItem('debitoAutomaticoContrato', JSON.stringify(contrato));
          this.router.navigate(['/BF-Portal/debitoautomaticocontrato']);
        }
        else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/debito-automatico/debito-automatico.component.ts